import ReactDOM from 'react-dom/client';
import App from "./App";
import "./index.scss";

import { ThemeProvider } from "@mui/material";
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { theme } from "./theme/Theme";

const root = document.getElementById("root") as HTMLElement;
const reactRoot = ReactDOM.createRoot(root);

reactRoot.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <ScrollToTop>
        <App />
      </ScrollToTop>
    </ThemeProvider>
  </BrowserRouter>
);